[
  {
    "code": "GD-01",
    "name": "Saint Andrew"
  },
  {
    "code": "GD-02",
    "name": "Saint David"
  },
  {
    "code": "GD-03",
    "name": "Saint George"
  },
  {
    "code": "GD-04",
    "name": "Saint John"
  },
  {
    "code": "GD-05",
    "name": "Saint Mark"
  },
  {
    "code": "GD-06",
    "name": "Saint Patrick"
  },
  {
    "code": "GD-10",
    "name": "Southern Grenadine Islands"
  }
]